export const ResponseStatus = {
    Success: 'success',
    Error: 'error',
}

export const VerificationType = {
    Email: 'email',
    Sms: 'sms',
}

export const ResponseCode = {
    Success: 200,
    Created: 201,

    BadRequest: 400,
    Unauthorized: 401,
    Forbidden: 403,
    NotFound: 404,
    Conflict: 409,
    TooManyRequests: 429,

    InternalServerError: 500,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
}

export const FORM_TEXT_FIELD_REGEXP = /^[a-zA-Zа-яА-ЯёЁ0-9 _.,'()\-]+$/u;

export const FORM_TAX_ID_FIELD_FORMAT_REGEXP = /^[a-zA-Z0-9-._/\\ ]{6,32}$/;

export const FORM_PHONE_REGEXP = /^\+\d{1,3}\s?\(?\d{1,4}\)?\s?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,4}$/;

export const FORM_TEXT_COMMENT_FIELD_REGEXP = /^[a-zA-Zа-яА-ЯёЁ0-9 _.,'()!?@"\-\t\r\n]+$/u;

export const WORKING_WITH_INTERNET_BANKING_LINK = "https://help.131.ru/";

export const BANK_ADDRESS = '420111, Российская Федерация, Республика Татарстан, город Казань, улица Карла Маркса, здание 28';

export const BANK_ADDRESS_EN = '420111, 28 Karla Marksa street, Kazan, Republic of Tatarstan, Russian Federation';

export const BANK_BIK = '049205131';

export const BANK_CORR_ACC = '30101810822029205131';

export const BANK_HELP_EMAIL = 'help@131.ru';

export const BANK_INN_KPP = '1655505780 / 165501001';

export const BANK_OGRN = '1241600056390';

export const BANK_PHONE = '88001001310';
